import { render, staticRenderFns } from "./TheWellboreProfile.vue?vue&type=template&id=785f5581"
import script from "./TheWellboreProfile.vue?vue&type=script&lang=ts"
export * from "./TheWellboreProfile.vue?vue&type=script&lang=ts"
import style0 from "./TheWellboreProfile.vue?vue&type=style&index=0&id=785f5581&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports